// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3Rhdm","footer":"ModalCreateQualiphyProcedure_footer__2xQly","additionData":"ModalCreateQualiphyProcedure_additionData__1HQ1P"};